import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import {
  BIG_MARGIN,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SUBMIDDLE_MARGIN,
  TINY_MARGIN,
} from '../../../../theme';

export const useJoinNowStyles = makeStyles((theme: Theme) =>
  createStyles({
    lockIcon: {
      marginTop: 10,
      [theme.breakpoints.up('md')]: {
        marginTop: 0,
      },
    },
    wrapper: {
      padding: 0,
      margin: `${LARGE_MARGIN}px 0`,
    },
    container: {
      padding: `${MIDDLE_MARGIN}px ${MIDDLE_MARGIN}px ${MIDDLE_MARGIN}px ${
        BIG_MARGIN + TINY_MARGIN
      }px`,
      margin: 0,
      [theme.breakpoints.up('md')]: {
        padding: `${SUBMIDDLE_MARGIN}px ${MIDDLE_MARGIN}px`,
      },
    },
    lockText: {
      fontSize: 18,
      margin: `0px 0px ${TINY_MARGIN}px`,
      [theme.breakpoints.up('md')]: {
        margin: 0,
        fontSize: 20,
        maxWidth: 85,
      },
    },
    description: {
      fontSize: 16,
      marginBottom: SUBMIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        margin: `0 ${SUBMIDDLE_MARGIN}px`,
      },
    },
  }),
);
